// Entry point: runs the module for the page named by <body data-page="...">.

import { describeError } from './api';
import { errorState } from './dom';
import { hydrateIcons } from './icons';
import { initAbout } from './page-about';
import { initAdmin } from './page-admin';
import { initH2H } from './page-h2h';
import { initLeaderboard } from './page-leaderboard';
import { initLive } from './page-live';
import { initMatch } from './page-match';
import { initMatches } from './page-matches';
import { initModel } from './page-model';
import { initOverview } from './page-overview';

const PAGES: Record<string, () => Promise<void>> = {
  overview: initOverview,
  leaderboard: initLeaderboard,
  matches: initMatches,
  match: initMatch,
  model: initModel,
  h2h: initH2H,
  live: initLive,
  about: initAbout,
  admin: initAdmin,
};

function fatal(err: unknown): void {
  console.error(err);
  const main = document.getElementById('main');
  main?.append(errorState(describeError(err), () => location.reload()));
}

window.addEventListener('unhandledrejection', (ev) => {
  // Every loader handles its own errors; this only keeps stray rejections out of the way.
  console.error('Unhandled rejection:', ev.reason);
  ev.preventDefault();
});

function boot(): void {
  try {
    hydrateIcons();
  } catch (err) {
    console.error(err);
  }
  const init = PAGES[document.body.dataset.page ?? ''];
  if (!init) return;
  try {
    init().catch(fatal);
  } catch (err) {
    fatal(err);
  }
}

boot();
